export default "__VITE_ASSET__7e3eb29e__"